export function updateCachedItem<T>(items: T[], updatedItem: T, getId: (item: T) => string | number): T[] {
    return items.map((item) => (getId(item) === getId(updatedItem) ? updatedItem : item));
}
